module.exports = __webpack_public_path__ + "imgs/BailProject.4671a6fc6a8edd32c91dd901f207ef65.png";